export const pad = (integer) => {
  return integer < 10 ? `0${integer}` : integer;
};
export const getHoursAndMinutes = (timeInMs) => {
  if (!timeInMs || timeInMs <= 0) {
    return "";
  }
  const date = new Date(timeInMs);
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
export const getDelayString = (delayInMs) => {
  let timeInMs = delayInMs;
  if (timeInMs < 0) {
    timeInMs = 0;
  }
  const h = Math.floor(timeInMs / 36e5);
  const m = Math.floor(timeInMs % 36e5 / 6e4);
  const s = Math.floor(timeInMs % 36e5 % 6e4 / 1e3);
  if (s === 0 && h === 0 && m === 0) {
    return "+0";
  }
  if (s === 0 && h === 0) {
    return `+${m}m`;
  }
  if (s === 0) {
    return `+${h}h${m}m`;
  }
  if (m === 0 && h === 0) {
    return `+${s}s`;
  }
  if (h === 0) {
    return `+${m}m${s}s`;
  }
  return `+${h}h${m}m${s}s`;
};
